import "./style.scss";

import type { CSSProperties } from "react";

interface ILightButton {
    text: string;
    onClick: () => void;
    style?: CSSProperties;
    disabled?: boolean;
    className?: string;
}

/**
 * Small outlined button in the app's primary blue (#275ab0).
 * Intended for secondary/informational actions (e.g. "Go to Advances / Packages").
 */
const LightButton = ({ text, onClick, style, disabled, className }: ILightButton) => (
    <button
        type="button"
        className={`light-button ${className ?? ""}`}
        onClick={onClick}
        disabled={disabled}
        style={style}
    >
        {text}
    </button>
);

export default LightButton;
